module.exports = __webpack_public_path__ + "static/media/tracy_08.1885711a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/album/tracy_08.jpg
// module id = 386
// module chunks = 0